import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-b border-line bg-night py-20 sm:py-24" data-id="element-73" data-mp="1bmd7383s4e5l">
      <div className="mx-auto grid max-w-5xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.6fr_1fr] lg:gap-16" data-id="element-74" data-mp="1gkn6juwje0x0">
        <div data-id="element-75" data-mp="24ahfw2hnd7ci">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-76" data-mp="249pshey7efxb">
            Frequently asked questions
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-77" data-mp="1ujmrargxhvnw">
            Before you decide
          </h2>
        </div>

        <ul className="divide-y divide-line border-y border-line" data-id="element-78" data-mp="2n825jbs8k9y6">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} data-id="element-79" data-mp="2s0bqedehujtl" data-mpi={i}>
                <h3 data-id="element-80" data-mp="2s0lfzzvmmoyr">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="group flex w-full items-center justify-between gap-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-acid" data-id="element-81" data-mp="14usfz29w8kuz">
                    <span className="font-display text-xl font-bold uppercase tracking-tight text-white transition-colors duration-150 ease-smooth group-hover:text-acid sm:text-2xl" data-id="element-82" data-mp="1oihzynbl9gtn">
                      {faq.q}
                    </span>
                    <PlusIcon className={['h-5 w-5 shrink-0 text-acid transition-transform duration-200 ease-smooth', isOpen ? 'rotate-45' : 'rotate-0'].join(' ')} aria-hidden="true" data-id="element-83" data-mp="1xj6dlgx2lf60" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-84" data-mp="1ya4tuoiarqtn">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-85" data-mp="237egjweaxods">
                      <p className="pb-6 pr-10 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-86" data-mp="2qxs9dp4pnr9f">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}